export const helperMessages = {
  campaignName:
    'Give your new campaign a name or search to start from a previous campaign',
  emptyProduct: `Most likely it's empty here because you haven't chosen advertisers`,
  copyWarning:
    'You have some filled in data, when you perform this action, they will be erased, are you sure for sure?',
  noSiteTitle: 'Add sites and media to your campaign',
} as const;
